import React from 'react'
import Divider from '@solid-ui-components/Divider'

const Spacer = ({  }) => (
  <Divider space='4' />
)

export default Spacer
